module.exports = __webpack_public_path__ + "static/media/info-button.b62edb29.svg";